// src/components/PleaseWait.jsx

import React from "react";
import "../styles/PleaseWait.css";

const PleaseWait = ({ message = "Please wait..." }) => {
  return (
    <div className="please-wait-overlay">
      <div className="please-wait-box">
        <span className="please-wait-message">{message}</span>
        <span className="dots">
          <span className="dot dot1">.</span>
          <span className="dot dot2">.</span>
          <span className="dot dot3">.</span>
        </span>
      </div>
    </div>
  );
};


export default PleaseWait;
